import React from 'react'

const PreferencesTab = () => {
    return (
        // {/* x---------------------------------x Preferences Tab Section x---------------------------------x */ }
        <div className="row">
            <div className="col-sm-12 my-3">
                <form>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label htmlFor="exampleFormControlInput1"
                                className="form-label text-dark fs-6 fw-normal ">Currency</label>
                            <input type="email"
                                className="form-control rounded-4  form-control-lg"
                                id="exampleFormControlInput2"
                                placeholder="USD" />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="time-zone"
                                className="form-label text-dark fs-6 fw-normal ">Time
                                Zone</label>
                            <input type="email"
                                className="form-control rounded-4  form-control-lg"
                                id="time-zone"
                                placeholder="(GMT-12:00) International Date Line West" />
                        </div>
                        <div className="col-md-12">
                            <div>
                                <p className="text-dark fs-6 fw-medium ">
                                    Notification</p>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div
                                className="form-check form-switch form-switch-lg d-flex align-items-center">
                                <input className="form-check-input "
                                    defaultChecked type="checkbox"
                                    role="switch"
                                    id="flexSwitchCheckDefault1" />
                                <label className="form-check-labe ms-4"
                                    htmlFor="flexSwitchCheckDefault1">I
                                    send or receive digita
                                    currency</label>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div
                                className="form-check form-switch form-switch-lg d-flex align-items-center">
                                <input className="form-check-input "
                                    type="checkbox" role="switch"
                                    id="flexSwitchCheckDefault2" />
                                <label className="form-check-labe ms-4"
                                    htmlFor="flexSwitchCheckDefault2">I
                                    send or receive digita
                                    currency</label>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div
                                className="form-check form-switch form-switch-lg d-flex align-items-center">
                                <input className="form-check-input "
                                    defaultChecked type="checkbox"
                                    role="switch"
                                    id="flexSwitchCheckDefault3" />
                                <label className="form-check-labe ms-4"
                                    htmlFor="flexSwitchCheckDefault3">I
                                    send or receive digita
                                    currency</label>
                            </div>
                        </div>
                        <div className="col-md-12 my-3">
                            <div className="row">
                                <div className="col-md-2 ms-auto">
                                    <button
                                        className="btn btn-primary w-100 rounded-3">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default PreferencesTab